import { createSvgIcon } from '@mui/material/utils';

export const MaterialDesignIcon = createSvgIcon(
  <g fill="none" fillRule="evenodd">
    <circle fill="#737373" cx="12" cy="12" r="12" />
    <path fill="#BDBDBD" d="M4 4h16v16H4z" />
    <path fill="#FFF" d="M12 20l8-16H4z" />
  </g>,
  'MaterialDesign',
);
